import React, { useEffect, useState } from 'react';
import { API_URLS } from '../../apiUrl';
import * as CryptoJS from "crypto-js";
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../components/axiosInstance';

export const EditMunicipality = ({ municipalityName, muniCipalityId, roleId, municipalityBanner, logo }: any) => {

 const [municipalityData, setMunicipalityData] = useState<any>({
        municipality_name: '',
        login_user_name: '',
        password: '',
        admin_name: '',
        municipality_chairman_person_name: '',
        municipality_offical_address: '',
        gst: '',
        tan: '',
        pan: '',
        state_id: '',
        city_id: '',
        email: '',
        municipality_id: muniCipalityId,
        role_id: roleId,
    });
 const [errors, setErrors] = useState<any>({
        municipality_name: '',
        admin_name: '',
        municipality_chairman_person_name: '',
        municipality_offical_address: '',
        gst: '',
        tan: '',
        pan: '',
        state_id: '',
        city_id: '',
        email: '',
        password: '',
        confirmPass: ''
    });
 const [changePassword, setChangePassword] = useState<any>({
        changePass: '',
        confirmPass: ''
    });
 const [logoFile, setLogoFile] = useState<any>(null);
 const [bannerFile, setBannerFile] = useState<any>(null);
 const [successMessage, setSuccessMessage] = useState<string>("");
 const [failedMessage, setfailedMessage] = useState<string>("");

    const resetForm = () => {
        setChangePassword({
            changePass: '',
            confirmPass: ''
        })
    }
    const validate = () => {
        const newErrors: any = {};
        const regex = /^[A-Za-z\s]*$/;
        if (!municipalityData.municipality_name.trim()) {
            newErrors.municipality_name = 'Municipality Name is required';
        } else if (!regex.test(municipalityData.municipality_name)) {
            newErrors.municipality_name = 'Municipality Name can only contain letters and spaces';
        }

        if (!municipalityData.admin_name.trim()) {
            newErrors.admin_name = 'Admin Name is required';
        } else if (!regex.test(municipalityData.admin_name)) {
            newErrors.admin_name = 'Admin Name can only contain letters and spaces';
        }

        if (!municipalityData.municipalty_chairman_person_name.trim()) {
            newErrors.municipalty_chairman_person_name = 'Municipalty chairman person name is required';
        } else if (!regex.test(municipalityData.municipalty_chairman_person_name)) {
            newErrors.municipalty_chairman_person_name = 'Municipalty chairman person name can only contain letters and spaces';
        }

        if (!municipalityData.municipalty_offical_address.trim()) {
            newErrors.municipalty_offical_address = 'Official Address is required';
        }

        if (!municipalityData.gst.trim()) {
            newErrors.gst = 'GST is required';
        } else {
            const gstPattern = /^[A-Z0-9]{15}$/
            if (!gstPattern.test(municipalityData.gst.trim())) {
                newErrors.gst = "Invalid GST format. Please provide a valid GST number (Characters Should be in Caps).";
            }
        }

        if(municipalityData?.tan?.trim()) {
            const tanPattern = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
            if (!tanPattern.test(municipalityData.tan.trim())) {
                newErrors.tan = "Invalid TAN format. Please provide a valid TAN number (Characters Should be in Caps).";
            }
        }

        if(municipalityData?.pan?.trim()) {
            const panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
            if (!panPattern.test(municipalityData.pan.trim())) {
                newErrors.pan = "Invalid PAN format. It should be in the format ABCD1234E (Characters Should be in Caps).";
            }
        }

        if (!municipalityData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(municipalityData.email)) {
            newErrors.email = 'Email address is invalid';
        }

        if (municipalityData.state_id === '0') {
            newErrors.state_id = 'State is required';
        }
        if (municipalityData.city_id === '0') {
            newErrors.city_id = 'City is required';
        }

        if (changePassword.changePass) {
            if (changePassword.changePass !== changePassword.confirmPass) {
                newErrors.confirmPass = 'Passwords do not match';
            }
        }

        if (changePassword.changePass) {
            if (changePassword.changePass !== changePassword.confirmPass) {
                newErrors.confirmPass = 'Passwords do not match';
            }
        
            const password = changePassword.changePass;
            const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{5,}$/;
        
            if (!passwordRegex.test(password)) {
                newErrors.confirmPass = 'Password must be at least 5 characters long, contain at least one special character, and one number';
            }
        }
        

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;  // Return true if no errors
    };

    const [municipalityLogo, setMunicipalityLogo] = useState<any>("");
    const [municipalityBannerforadmin, setMunicipalityBannerforadmin] = useState<any>("");

    const location = useLocation();
    const { getMunicipalityIdFromSuperAdmin } = location.state || {};



    const fetchMunicipalityData = async () => {
        try {

            const municipalityIdToUse = roleId == 1 ? getMunicipalityIdFromSuperAdmin : muniCipalityId;
            const response = await axiosInstance.post(`${API_URLS.MunicipalityDetails}`, {
                municipalityTbl_id: municipalityIdToUse,
            });

            setMunicipalityData(response.data.data[0]);
            setMunicipalityLogo(response.data.data[0].logo);
            setMunicipalityBannerforadmin(response.data.data[0].banner_image)

        } catch (error) {
            console.error('Error fetching municipality data', error);
        }
    };


   
    useEffect(() => {
        fetchMunicipalityData();
    }, [getMunicipalityIdFromSuperAdmin, logo]);

    localStorage.setItem("getMunicipalityIdFromSuperAdmin", getMunicipalityIdFromSuperAdmin);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, type: 'logo' | 'banner') => {
        const file = e.target.files ? e.target.files[0] : null;
        if (type === 'logo') {
            setLogoFile(file);
        } else if (type === 'banner') {
            setBannerFile(file);
        }
    };



    const handleFormSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!validate()) {
            return; 
        }

        const municipalityIdToUse = roleId == 1 ? getMunicipalityIdFromSuperAdmin : muniCipalityId;

        const updatedFormData: any = { ...municipalityData, municipality_id: municipalityIdToUse };

        if (changePassword.changePass) {
            const hashedPassword = CryptoJS.MD5(changePassword.confirmPass).toString();
            updatedFormData.password = hashedPassword;
        }

        const formData = new FormData();
        for (let key in updatedFormData) {
            if (updatedFormData[key] !== null && updatedFormData[key] !== undefined && key !== 'logo' && key !== 'banner_image') {
                formData.append(key, updatedFormData[key]);
            }
        }
        if (logoFile) {
            formData.append('logo', logoFile); 
        } else {
            formData.append('logo', municipalityLogo);
        }

        if (bannerFile) {
            formData.append('banner_image', bannerFile); 
        } else {
            formData.append('banner_image', municipalityBannerforadmin); 
        }

        try {
            const response = await axiosInstance.post(`${API_URLS.MunicipalityProfileUpdate}`, formData);

            if (response.status === 201) {
                localStorage.setItem("municipalityLogo", response.data.data.data.logo );
                localStorage.setItem("municipalityBanner", response.data.data.data.banner_image); 
                setSuccessMessage(`${response.data.data.message}`);
                setTimeout(() => {
                    setSuccessMessage("");
                }, 5000);
            } else {
                setfailedMessage(`Municipality Not Updated`);
                setTimeout(() => {
                    setfailedMessage("Municipality Not Updated");
                }, 5000);
            }
        } catch (error) {
            console.error('Error updating municipality data', error);
        } finally {
            resetForm();
        }
    };


    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;

        if (name === 'changePass' || name === 'confirmPass') {
            setChangePassword({
                ...changePassword,
                [name]: value,
            });
        } else {
            setMunicipalityData((prevData: any) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const imagePathLogo = logo?.replace("/var/www/html/SurveyApp/dev", "");
    const imagePathBanner = municipalityBanner?.replace("/var/www/html/SurveyApp/dev", "");


    return (
        <div className="p-6 w-full bg-white rounded-lg shadow-lg dark:bg-gray-800">
            <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100 mb-4">Edit Municipality</h1>
            <form onSubmit={handleFormSubmit}>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-2">
                    <div>
                        <label htmlFor="municipality_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Municipality Name <span className="text-red-600">*</span>
                        </label>
                        <input
                            type="text"
                            id="municipality_name"
                            name="municipality_name"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.municipality_name}
                            onChange={handleChange}
                            disabled
                        />
                        {errors.municipality_name && (
                            <span className="text-sm text-red-600">{errors.municipality_name}</span>
                        )}
                    </div>


                    <div>
                        <label htmlFor="login_user_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Login User Name <span className="text-red-600">*</span>
                        </label>
                        <input
                            type="text"
                            id="login_user_name"
                            name="login_user_name"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.login_user_name}
                            onChange={handleChange}
                            disabled
                        />

                    </div>


                    <div>
                        <label htmlFor="admin_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Admin Name <span className="text-red-600">*</span>
                        </label>
                        <input
                            type="text"
                            id="admin_name"
                            name="admin_name"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.admin_name}
                            onChange={handleChange}
                        />
                        {errors.admin_name && (
                            <span className="text-sm text-red-600">{errors.admin_name}</span>
                        )}
                    </div>


                    <div>
                        <label htmlFor="municipalty_chairman_person_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Municipality Chairman Name
                        </label>
                        <input
                            type="text"
                            id="municipalty_chairman_person_name"
                            name="municipalty_chairman_person_name"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.municipalty_chairman_person_name}
                            onChange={handleChange}
                        />

                        {errors.municipalty_chairman_person_name && (
                            <span className="text-sm text-red-600">{errors.municipalty_chairman_person_name}</span>
                        )}
                    </div>



                    <div>
                        <label htmlFor="municipalty_offical_address" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Municipality Official Address
                        </label>
                        <input
                            type="text"
                            id="municipalty_offical_address"
                            name="municipalty_offical_address"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.municipalty_offical_address}
                            onChange={handleChange}
                        />
                        {errors.municipalty_offical_address && (
                            <span className="text-sm text-red-600">{errors.municipalty_offical_address}</span>
                        )}
                    </div>

                    <div>
                        <label htmlFor="gst" className="flex gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            GST <span className="text-red-600">*</span>  <span className="text-red-500 block text-xs font-medium leading-1">(E.g. 29GGGGG1314R9Z6)</span>
                        </label>
                        <input
                            type="text"
                            id="gst"
                            name="gst"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.gst}
                            onChange={handleChange}
                            disabled={roleId == 2}
                        />
                        {errors.gst && (
                            <span className="text-sm text-red-600">{errors.gst}</span>
                        )}
                    </div>


                    <div>
                        <label htmlFor="tan" className="flex gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            TAN 
                            <span className="text-red-500 block text-xs font-medium leading-1">(E.g. ABCD12345K)</span>
                        </label>
                        <input
                            type="text"
                            id="tan"
                            name="tan"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.tan}
                            onChange={handleChange}
                            disabled={roleId == 2}
                        />
                        {errors.tan && (
                            <span className="text-sm text-red-600">{errors.tan}</span>
                        )}
                    </div>


                    <div>
                        <label htmlFor="pan" className="flex gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            PAN 
                            <span className="text-red-500 block text-xs font-medium leading-1">(E.g. ABCDE6789K)</span>
                        </label>
                        <input
                            type="text"
                            id="pan"
                            name="pan"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.pan}
                            onChange={handleChange}
                            disabled={roleId == 2}
                        />
                        {errors.pan && (
                            <span className="text-sm text-red-600">{errors.pan}</span>
                        )}
                    </div>


                    <div>
                        <label htmlFor="state_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            State <span className="text-red-600">*</span>
                        </label>
                        <select
                            id="state_id"
                            name="state_id"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.state_id}
                            onChange={handleChange}
                        >
                            <option value="0">Select State</option>
                            <option value="1">West Bengal</option>
                        </select>
                    </div>


                    <div>
                        <label htmlFor="city_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            City <span className="text-red-600">*</span>
                        </label>
                        <select
                            id="city_id"
                            name="city_id"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.city_id}
                            onChange={handleChange}
                        >
                            <option value="0">Select City</option>
                            <option value="1">Kolkata</option>
                            <option value="2">Tamluk</option>
                        </select>
                    </div>


                    <div>
                        <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Email <span className="text-red-600">*</span>
                        </label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={municipalityData?.email}
                            onChange={handleChange}
                        />
                        {errors.email && (
                            <span className="text-sm text-red-600">{errors.email}</span>
                        )}
                    </div>
                    <div className="col-span-2 mt-2">
                        <hr />
                    </div>

                    {roleId == 1 ? null :
                        <>
                        <div className='flex items-center gap-2'>
                            
                            <div className='w-24 h-24 float-none rounded-lg border border-slate-300 mb-2 overflow-hidden'>
                            {logo == undefined || logo == null || logo == "null" ?
                              <img src="/assets/surveyLogo.png" alt="Logo" className="w-full h-full object-cover" /> :

                                <img  src={`${process.env.REACT_APP_API_URL}${imagePathLogo}`}  alt="" className='w-full h-full object-cover' />}
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-900 dark:text-white" htmlFor="file_logo">
                                    Upload Logo
                                </label>
                                <span className="block mb-2 text-xs font-medium text-gray-600 dark:text-white text-red-600">Logo Size:- 100px * 100px (.jpg , .png)</span>
                                <input
                                    type="file"
                                    id="file_logo"
                                    onChange={(e) => handleFileChange(e, 'logo')}
                                    className="text-sm bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:outline-none focus:ring-blue-600 focus:border-blue-600 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 file:cursor-pointer cursor-pointer file:border-0 file:py-2.5 file:px-4 file:mr-4 file:bg-gray-800 file:hover:bg-gray-900 file:text-white" aria-describedby="user_avatar_help" />
                            </div>
                           </div>
                           <div className='flex items-center gap-2'>
                            
                            <div className='w-24 h-24 float-none rounded-lg border border-slate-300 mb-2 overflow-hidden'> 
                            {municipalityBanner === undefined || municipalityBanner === null || municipalityBanner === "null" ? 
                            <img src="/assets/dummy3.jpg" alt="" /> :
                            <img  src={`${process.env.REACT_APP_API_URL}${imagePathBanner}`}  alt="" className='w-full h-full object-cover' /> }
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-900 dark:text-white" htmlFor="file_banner">
                                    Upload Banner
                                </label>
                                <span className="block mb-2 text-xs font-medium text-gray-600 dark:text-white text-red-600">Banner Size:- 1600px * 300px (.jpg , .png)</span>
                                <input
                                    type="file"
                                    id="file_banner"
                                    onChange={(e) => handleFileChange(e, 'banner')}
                                    className="text-sm bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:outline-none focus:ring-blue-600 focus:border-blue-600 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 file:cursor-pointer cursor-pointer file:border-0 file:py-2.5 file:px-4 file:mr-4 file:bg-gray-800 file:hover:bg-gray-900 file:text-white" aria-describedby="user_avatar_help" />
                            </div>
                        </div>
                        </>}

                    <div className="col-span-2 mt-2">
                        <hr />
                    </div>

                    <div className="col-span-2">
                        <label className="text-xl font-semibold">Change Password</label>
                    </div>


                    <div>
                        <label htmlFor="changePass" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Password
                        </label>
                        <input
                            type="txt"
                            id="changePass"
                            name="changePass"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={changePassword.changePass}
                            placeholder='E.g. Test@1234'
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label htmlFor="confirmPass" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                            Confirm Password
                        </label>
                        <input
                            type="password"
                            id="confirmPass"
                            name="confirmPass"
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={changePassword.confirmPass}
                             placeholder='E.g. Test@1234'
                            onChange={handleChange}
                        />
                        {errors.confirmPass && (
                            <span className="text-sm text-red-600">{errors.confirmPass}</span>
                        )}
                    </div>


                    <div className="mt-3 sm:col-span-2 flex justify-center">
                        <button
                            type="submit"
                            className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                            Update Profile
                        </button>
                    </div>
                </div>
            </form>

            {successMessage && (
                <div className="mt-4 p-4 bg-green-600 text-white rounded-lg flex justify-between items-center">
                    <span>{successMessage}</span>
                    <button
                        onClick={() => setSuccessMessage('')}
                        className="ml-4 text-white font-bold text-lg focus:outline-none"
                    >
                        &times;
                    </button>
                </div>
            )}


            {failedMessage && (
                <div className="mt-4 p-4 bg-red-600 text-white rounded-lg flex justify-between items-center">
                    <span>{failedMessage}</span>
                    <button
                        onClick={() => setfailedMessage('')}
                        className="ml-4 text-white font-bold text-lg focus:outline-none"
                    >
                        &times;
                    </button>
                </div>
            )}

        </div>
    );
};
